import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { DisplayItem } from './item';
import { Value } from './value';
import type { Schema, SchemaFieldType, Values } from '../..';
import type { CustomValue } from './value/registry';
interface Props {
  name: string;
  schema: Schema;
  values: Values;
}

/**
 * Renders a singular display item given the schema, values, and property key name
 * @param props
 */
export function SchemaDisplayItem(props) {
  const $ = _c(6);
  const {
    name,
    schema,
    values
  } = props;
  let t0;
  if ($[0] !== schema.properties) {
    t0 = schema.properties || {};
    $[0] = schema.properties;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const field = t0[name] as SchemaFieldType;
  if (!field?.inputType) {
    return null;
  }
  const t1 = values[name];
  let t2;
  if ($[2] !== field || $[3] !== name || $[4] !== t1) {
    t2 = <DisplayItem name={name} field={field} value={t1} />;
    $[2] = field;
    $[3] = name;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}

/**
 * Allows to extend Value by adding new inputType handlers
 * @param inputType
 * @param customValue
 */
SchemaDisplayItem.registerComponent = (inputType: string, customValue: CustomValue<any, any>, getStringifiedFieldValue?: (value: any, field?: any) => string | null) => {
  Value.registerComponent(inputType, customValue, getStringifiedFieldValue);
};